export const DOCUMENT_TYPES_BASE_PATH = 'types-de-documents';
export const DOCUMENT_TYPE_LIST = '/types-de-documents/liste';
export const DOCUMENT_TYPE_NEW = '/types-de-documents/ajouter';
